module.exports = __webpack_public_path__ + "static/media/PM53.f58e80ad.JPG";